import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Lang } from '../types/copy';
const LANGS: {
  code: Lang;
  name: string;
}[] = [{
  code: 'en',
  name: 'English'
}, {
  code: 'es',
  name: 'Español'
}];
export function LanguageToggle() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div role="group" aria-label={t.nav.language} className="flex items-center text-[12px] font-semibold tracking-[0.16em]" data-id="element-209" data-mp="2t8tggij5w4o9">
      {LANGS.map((l, i) => <React.Fragment key={l.code} data-id="element-210" data-mp="21hdmu4j6thoj" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className="px-0.5 opacity-40" data-id="element-211" data-mp="21erhmbjrre9h">
              /
            </span>}
          <button type="button" lang={l.code} aria-pressed={lang === l.code} onClick={() => setLang(l.code)} className={`h-11 px-1.5 uppercase transition-opacity duration-150 ${lang === l.code ? 'underline decoration-1 underline-offset-[6px]' : 'opacity-60 hover:opacity-100'}`} data-id="element-212" data-mp="2ah90qh44nqs9">
            <span className="sr-only" data-id="element-213" data-mp="1bw3sanpc0o73">{l.name}</span>
            <span aria-hidden="true" data-id="element-214" data-mp="1buss0xv3hykq">{l.code}</span>
          </button>
        </React.Fragment>)}
    </div>;
}